// extracted by mini-css-extract-plugin
module.exports = {"inLineBusModalWrap":"RichText_inLineBusModalWrap__MSBsV","RichTextWrap":"RichText_RichTextWrap__ggWpW"};